import { defineComponent, reactive, computed } from '@vue/composition-api';
export default defineComponent({
    props: ['prop'],
    setup(props, context) {
        // ================
        //
        // state
        //
        let state = reactive({
            info: false,
            infoTitle: '',
            infoContent: ''
        });
        // ================
        //
        // computed
        //
        let supports = computed(() => props.prop.supports.items);
        // ================
        //
        // methods
        //
        let select = (support) => {
            context.emit('select', support);
        };
        let openInfo = (support) => {
            state.info = true;
            state.infoTitle = support.name;
            state.infoContent = support.info;
        };
        return {
            state,
            select,
            openInfo,
            supports
        };
    }
});
